import { useEffect, useMemo, useState } from "react";
import MultiSelect from "@/components/MultiSelect";
import { X } from "lucide-react";

const vals = (r, f) => { const v = f.get ? f.get(r) : r[f.key]; return (Array.isArray(v) ? v : [v]).filter((x) => x !== null && x !== undefined && x !== "").map(String); };
const sortOpts = (f, list) => (f.order ? list.sort((a, b) => f.order.indexOf(a) - f.order.indexOf(b)) : list.sort());

const DUR = ["Not called", "0 sec (not connected)", "Under 30 sec", "30 sec – 2 min", "2 – 5 min", "5 – 10 min", "Over 10 min"];
const bucket = (s, called) => (!called ? DUR[0] : s <= 0 ? DUR[1] : s < 30 ? DUR[2] : s < 120 ? DUR[3] : s < 300 ? DUR[4] : s < 600 ? DUR[5] : DUR[6]);
export const durationFilters = [
  { key: "last_call_duration", label: "Last Call Durations", order: DUR, get: (r) => bucket(r.last_call_duration || 0, r.calls_count_logged || !!r.last_call_at) },
  { key: "talk_seconds", label: "Total Talk Times", order: DUR, get: (r) => bucket(r.talk_seconds || 0, r.calls_count_logged || !!r.last_call_at) },
];

// fields must be a stable (module-level or memoized) array of { key, label, get? }
export default function QuickFilters({ rows, fields, onFiltered, testid, initial, storageKey }) {
  const [sel, setSel] = useState(() => initial || (storageKey && JSON.parse(sessionStorage.getItem(`qf:${storageKey}`) || "null")) || {});
  useEffect(() => { if (storageKey) sessionStorage.setItem(`qf:${storageKey}`, JSON.stringify(sel)); }, [sel, storageKey]);
  const opts = useMemo(() => Object.fromEntries(fields.map((f) => [f.key, sortOpts(f, [...new Set((rows || []).flatMap((r) => vals(r, f)))])])), [rows, fields]);
  const out = useMemo(() => (rows == null ? null : rows.filter((r) => fields.every((f) => !(sel[f.key] || []).length || vals(r, f).some((x) => sel[f.key].includes(x))))), [rows, sel, fields]);
  useEffect(() => { onFiltered(out); }, [out]); // eslint-disable-line
  const active = Object.values(sel).some((v) => v.length);
  return (
    <div className="flex flex-wrap items-center gap-2 mb-3" data-testid={`${testid}-quick-filters`}>
      {fields.map((f) => (
        <MultiSelect key={f.key} label={`All ${f.label}`} options={opts[f.key]} value={sel[f.key] || []} onChange={(v) => setSel((s) => ({ ...s, [f.key]: v }))} testid={`${testid}-qf-${f.key}`} width="w-44" />
      ))}
      {active && (
        <button onClick={() => setSel({})} className="h-10 px-3 text-xs text-rose-600 hover:bg-rose-50 rounded-md flex items-center gap-1" data-testid={`${testid}-qf-clear`}>
          <X className="w-3.5 h-3.5" /> Clear filters
        </button>
      )}
    </div>
  );
}
